import { isNotNil } from '@flowio/is';
import getOwnerWindow from './getOwnerWindow';
import getOwnerDocument from './getOwnerDocument';
/**
 * Determines whether the specified element is within the viewport.
 */

export default function isElementInViewport(element) {
  var rect = element.getBoundingClientRect();
  var window = getOwnerWindow(element);
  var document = getOwnerDocument(element);
  var windowHeight = isNotNil(window) && window.innerHeight || document.documentElement.clientHeight;
  var windowWidth = isNotNil(window) && window.innerWidth || document.documentElement.clientWidth;
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= windowHeight && rect.right <= windowWidth;
}
//# sourceMappingURL=isElementInViewport.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/blaze-consumer/~/@flowio/browser-helpers/lib/esm/isElementInViewport.js
// module id = 481
// module chunks = 0 1